// extracted by mini-css-extract-plugin
module.exports = {"pagination":"style_pagination__2sTy2"};